export default __webpack_public_path__ + "static/media/header.7bb050df.jpg";